module.exports = __webpack_public_path__ + "img/personal-web-responsive.c772f70c.jpg";